import axios from "axios";
import { url } from "../baseUrl";

export const FindingStore = {
  state: {
    all: []
  },
  mutations: {
    getallfindings(state, data) {
      state.all = data.map(item => ({
        id: item.id,
        label: item.description,
        value: item.ignore
      }));
    },
    updateFindings(state, data) {
      state.all = data.findings.map(item => ({
        id: item.id,
        label: item.description,
        value: item.ignore
      }));
    }
  },
  actions: {
    getAllFindings(context) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/configuration/findings/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            context.commit("getallfindings", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    updateFindings(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/configuration/findings/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: {
            findings: data
          },
          method: "PUT"
        })
          .then(response => {
            context.commit("updateFindings", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
